module.exports = __webpack_public_path__ + "img/ferie2.f0924a6d.png";